import {ethiotelConfig} from "@/config";
import axios from "axios";

export default class OnevasService {
    static async getUsers(msisdn, productId) {
        return await axios.post(`${ethiotelConfig.host}/user/get`, {
            msisdn,
            productId,
        } )
    }

    static async queueUserSubscription(correlationId, msisdn, serviceId, productId, campaignId, clickId, publisherId, subpublisherId, gclid) {
        const payload = {
            msisdn,
            serviceId: serviceId.toString(),
            productId,
            campaignId,
            channel: 'Web',
            clickId,
            gclid,
            publisherId,
            subpublisherId,
            correlationId,

        };

        console.log(`Queue user subscription payload: ${JSON.stringify(payload)}`);

        return await axios.post(`${ethiotelConfig.host}/user/queue-user-subscription`, payload)
    }

    static async upsertUserViaProductId(correlationId, msisdn, serviceId, productId, campaignId, clickId){
        return await axios.post(`${ethiotelConfig.host}/user/upsert-user-via-product-id`,
            {
                correlationId: correlationId.toString(),
                serviceId: serviceId.toString(),
                campaignId,
                clickId,
                msisdn,
                productId,
                status: 'ACTIVE',
                statusId: 1,
                subscriptionStarted: new Date().toISOString()
            })
    }
}
